<template>
<div>
  <div class="pony-heading">
    <InfoSectionHeading>{{pony.name}}</InfoSectionHeading>
    <div class="pony-stat" v-if="pony.averagePrice > 0">
      <span class="pony-stat-label">Average Price: </span>
      <span class="pony-stat-amount">{{currency(pony.averagePrice)}}</span>
    </div>
  </div>
  <h3 class="info-section-subheading">{{pony.notes}}</h3>
  <h3 class="info-section-subheading">Variants: {{pony.numVariants}}</h3>
</div>
</template>

<script>
import { currency } from '../../utils/helpers';
import InfoSectionHeading from '../InfoSectionHeading/InfoSectionHeading';

export default {
  name: 'PonyHeading',
  props: {
    pony: {
      type: Object,
      required: true
    }
  },
  components: {
    InfoSectionHeading
  },
  methods: {
    currency
  }
};
</script>
